import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const isDayTime = () => {
  const now = new Date()
  const hours = now.getHours()
  const minutes = now.getMinutes()
  const currentTime = hours * 60 + minutes
  return currentTime >= 481 && currentTime <= 1050
}

export default new Vuex.Store({
  state: {
    theme: isDayTime() ? 'light' : 'dark',
    // 控制参数
    isDayMode: true,
    ladderUp: false,
    platformRotation: 0,
    armExtension: 6,
    liftHeight: 3,
    autoResetCamera: true,
    enableAO: true,
    // GTAO参数
    gtaoOutput: 'Default',
    blendIntensity: 0.64,
    // AO参数
    aoRadius: 1.00,
    distanceExponent: 1.00,
    thickness: 10.00,
    distanceFallOff: 1.00,
    scale: 2.00,
    aoSamples: 32,
    // 加载状态
    isLoading: true,

    // 骨骼007动画控制
    bone007AnimationPlaying: false,
    bone007AnimationPaused: false,

    // 天空和地面颜色设置
    // 白天模式颜色
    dayModeColors: {
      skyTop: '#A0B2C7',      // 天空顶部颜色（深蓝绿色）
      skyMiddle: '#A0B2C7',   // 天空中部颜色（浅蓝灰色）
      skyBottom: '#FFFFFF',   // 天空底部颜色（白色地平线）
      horizonRange: 0.2,     // 地平线渐变范围 (0-1)
      groundColor: '#A0B2C7'  // 白天地面颜色（深色）
    },
    // 夜晚模式颜色
    nightModeColors: {
      skyTop: '#000000',      // 天空顶部颜色（黑色）
      skyMiddle: '#1a2332',   // 天空中部颜色（深蓝色）
      skyBottom: '#A0B2C7',   // 天空底部颜色（深蓝色地平线）
      horizonRange: 0.40,     // 地平线渐变范围 (0-1)
      groundColor: '#A0B2C7'  // 夜间地面颜色（深色）
    }
    
  },
  getters: {
    theme: state => state.theme,
    // 控制参数 getters
    isDayMode: state => state.isDayMode,
    ladderUp: state => state.ladderUp,
    platformRotation: state => state.platformRotation,
    armExtension: state => state.armExtension,
    liftHeight: state => state.liftHeight,
    autoResetCamera: state => state.autoResetCamera,
    enableAO: state => state.enableAO,
    gtaoOutput: state => state.gtaoOutput,
    blendIntensity: state => state.blendIntensity,
    aoRadius: state => state.aoRadius,
    distanceExponent: state => state.distanceExponent,
    thickness: state => state.thickness,
    distanceFallOff: state => state.distanceFallOff,
    scale: state => state.scale,
    aoSamples: state => state.aoSamples,
    isLoading: state => state.isLoading,

    bone007AnimationPlaying: state => state.bone007AnimationPlaying,
    bone007AnimationPaused: state => state.bone007AnimationPaused,

    // 天空和地面颜色 getters
    dayModeColors: state => state.dayModeColors,
    nightModeColors: state => state.nightModeColors,
    groundColor: state => state.isDayMode ? state.dayModeColors.groundColor : state.nightModeColors.groundColor
  },
  mutations: {
    toggleTheme(state) {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.theme);
    },
    updateThemeByTime(state) {
      const targetTheme = isDayTime() ? 'light' : 'dark'
      if (state.theme !== targetTheme) {
        state.theme = targetTheme
        localStorage.setItem('theme', targetTheme)
      }
    },
    // 控制参数 mutations
    setIsDayMode(state, value) {
      state.isDayMode = value;
    },
    setLadderUp(state, value) {
      state.ladderUp = value;
    },
    setPlatformRotation(state, value) {
      state.platformRotation = value;
    },
    setArmExtension(state, value) {
      state.armExtension = value;
    },
    setLiftHeight(state, value) {
      state.liftHeight = value;
    },
    setAutoResetCamera(state, value) {
      state.autoResetCamera = value;
    },
    setEnableAO(state, value) {
      state.enableAO = value;
    },
    setGtaoOutput(state, value) {
      state.gtaoOutput = value;
    },
    setBlendIntensity(state, value) {
      state.blendIntensity = value;
    },
    setAoRadius(state, value) {
      state.aoRadius = value;
    },
    setDistanceExponent(state, value) {
      state.distanceExponent = value;
    },
    setThickness(state, value) {
      state.thickness = value;
    },
    setDistanceFallOff(state, value) {
      state.distanceFallOff = value;
    },
    setScale(state, value) {
      state.scale = value;
    },
    setAoSamples(state, value) {
      state.aoSamples = value;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },

    setBone007AnimationPlaying(state, value) {
      state.bone007AnimationPlaying = value;
    },
    setBone007AnimationPaused(state, value) {
      state.bone007AnimationPaused = value;
    },

    // 天空和地面颜色 mutations
    setDayModeColors(state, colors) {
      state.dayModeColors = { ...state.dayModeColors, ...colors };
    },
    setNightModeColors(state, colors) {
      state.nightModeColors = { ...state.nightModeColors, ...colors };
    },
    // 重置所有参数
    resetAllParams(state) {
      state.isDayMode = true;
      state.ladderUp = false;
      state.platformRotation = 0;
      state.armExtension = 6;
      state.liftHeight = 0;
      state.autoResetCamera = true;
      state.enableAO = true;
      state.gtaoOutput = 'Default';
      state.blendIntensity = 0.64;
      state.aoRadius = 1.00;
      state.distanceExponent = 1.00;
      state.thickness = 10.00;
      state.distanceFallOff = 1.00;
      state.scale = 2.00;
      state.aoSamples = 32;
      state.bone007AnimationPlaying = false;
      state.bone007AnimationPaused = false;
      
      // 重置颜色设置
      state.dayModeColors = {
        skyTop: '#87CEEB',
        skyMiddle: '#B0E0E6',
        skyBottom: '#F5F8FF',
        horizonRange: 0.3
      };
      state.nightModeColors = {
        skyTop: '#0F1419',
        skyMiddle: '#1a2332',
        skyBottom: '#2a3442',
        horizonRange: 0.4
      };
      state.groundColor = '#787878';
    }
  },
  actions: {
    startThemeAutoUpdate({ commit }) {
      commit('updateThemeByTime')
    },
    toggleTheme({ commit }) {
      commit('toggleTheme');
    },
    // 控制参数 actions
    updateIsDayMode({ commit }, value) {
      commit('setIsDayMode', value);
    },
    updateLadderUp({ commit }, value) {
      commit('setLadderUp', value);
    },
    updatePlatformRotation({ commit }, value) {
      commit('setPlatformRotation', value);
    },
    updateArmExtension({ commit }, value) {
      commit('setArmExtension', value);
    },
    updateLiftHeight({ commit }, value) {
      commit('setLiftHeight', value);
    },
    updateAutoResetCamera({ commit }, value) {
      commit('setAutoResetCamera', value);
    },
    updateEnableAO({ commit }, value) {
      commit('setEnableAO', value);
    },
    updateGtaoOutput({ commit }, value) {
      commit('setGtaoOutput', value);
    },
    updateBlendIntensity({ commit }, value) {
      commit('setBlendIntensity', value);
    },
    updateAoRadius({ commit }, value) {
      commit('setAoRadius', value);
    },
    updateDistanceExponent({ commit }, value) {
      commit('setDistanceExponent', value);
    },
    updateThickness({ commit }, value) {
      commit('setThickness', value);
    },
    updateDistanceFallOff({ commit }, value) {
      commit('setDistanceFallOff', value);
    },
    updateScale({ commit }, value) {
      commit('setScale', value);
    },
    updateAoSamples({ commit }, value) {
      commit('setAoSamples', value);
    },
    updateIsLoading({ commit }, value) {
      commit('setIsLoading', value);
    },

    updateBone007AnimationPlaying({ commit }, value) {
      commit('setBone007AnimationPlaying', value);
    },
    updateBone007AnimationPaused({ commit }, value) {
      commit('setBone007AnimationPaused', value);
    },

    // 天空和地面颜色 actions
    updateDayModeColors({ commit }, colors) {
      commit('setDayModeColors', colors);
    },
    updateNightModeColors({ commit }, colors) {
      commit('setNightModeColors', colors);
    },
    resetAllParameters({ commit }) {
      commit('resetAllParams');
    }
  },
  modules: {
  }
})
